import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import {
  getPayment,
  savePaymentBySubscription,
  updatePayment,
} from './PaymentService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Checkbox, FormControlLabel } from '@mui/material';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const PaymentDetail = (): JSX.Element => {
  //const { sectionid, itemid } = useParams();
  //   const { sectionid = '' } = useParams<{ sectionid: string }>();
  //   const { itemid = '' } = useParams<{ itemid: string }>();
  const [paymentName, setPaymentName] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [currency, setCurrency] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [paymentFrequency, setPaymentFrequency] = useState('');
  const [status, setStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [enabled, setEnabled] = useState(false); // Initialize as false
  const navigate = useNavigate();
  const { subscriptionid } = useParams();
  const { paymentid } = useParams();
  const { membershipid } = useParams();

  function clearPaymentDetailsForm() {
    setPaymentName('');
    setPaymentAmount('');
    setCurrency('');
    setPaymentMethod('');
    setTransactionId('');
    setPaymentFrequency('');
    setStatus('');
    setStartDate('');
    setEndDate('');
    setEnabled(false);
  }

  const cancelSaveOrUpdatePayment = () => {
    clearPaymentDetailsForm();
    // navigate(`/system/account/{accountid}`)
    navigate(
      `/system/dashboard/membership/${membershipid}/subscription/${subscriptionid}`,
    );
  };

  function saveOrUpdatePayment(e) {
    e.preventDefault();

    const payment = {
      paymentName,
      paymentAmount,
      currency,
      paymentMethod,
      transactionId,
      paymentFrequency,
      status,
      startDate,
      endDate,
      enabled,
    };

    if (paymentid) {
      updatePayment(paymentid, payment)
        .then(() => {
          navigate(
            `/system/dashboard/membership/${membershipid}/subscription/${subscriptionid}`,
          );
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      savePaymentBySubscription(subscriptionid, payment)
        .then(() => {
          navigate(
            `/system/dashboard/membership/${membershipid}/subscription/${subscriptionid}`,
          );
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (paymentid) {
      console.log('paymentid exists: ', paymentid);
      getPayment(subscriptionid, paymentid)
        .then((response) => {
          console.log(response.data);
          setPaymentName(response.data.paymentName);
          setPaymentAmount(response.data.paymentAmount);
          setCurrency(response.data.currency);
          setPaymentMethod(response.data.paymentMethod);
          setTransactionId(response.data.transactionId);
          setPaymentFrequency(response.data.paymentFrequency);
          setStartDate(response.data.startDate);
          setEndDate(response.data.endDate);
          setStatus(response.data.status);
          setEnabled(response.data.enabled);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [subscriptionid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Accounts
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/subscriptions'}
            >
              Subscriptions
            </Link>
            <Typography color="text.primary">Payment Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Payment Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Payment Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'paymentName'}
                  fullWidth
                  value={paymentName} // Use the 'sequence' state variable as the value
                  onChange={(event) => setPaymentName(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Payment Amount
                </Typography>
                <TextField
                  variant="outlined"
                  name={'paymentAmount'}
                  fullWidth
                  value={paymentAmount} // Use the 'sequence' state variable as the value
                  onChange={(event) => setPaymentAmount(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Currency
                </Typography>
                <TextField
                  variant="outlined"
                  name={'currency'}
                  fullWidth
                  value={currency} // Use the 'sequence' state variable as the value
                  onChange={(event) => setCurrency(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Payment Method
                </Typography>
                <TextField
                  variant="outlined"
                  name={'paymentMethod'}
                  fullWidth
                  value={paymentMethod} // Use the 'sequence' state variable as the value
                  onChange={(event) => setPaymentMethod(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Transaction Id
                </Typography>
                <TextField
                  variant="outlined"
                  name={'transactionId'}
                  fullWidth
                  value={transactionId} // Use the 'sequence' state variable as the value
                  onChange={(event) => setTransactionId(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Payment Frequency
                </Typography>
                <TextField
                  variant="outlined"
                  name={'paymentFrequency'}
                  fullWidth
                  value={paymentFrequency} // Use the 'sequence' state variable as the value
                  onChange={(event) => setPaymentFrequency(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Start Date
                </Typography>
                <TextField
                  variant="outlined"
                  name={'startDate'}
                  fullWidth
                  value={startDate} // Use the 'name' state variable as the value
                  onChange={(event) => setStartDate(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  End Date
                </Typography>
                <TextField
                  variant="outlined"
                  name={'endDate'}
                  fullWidth
                  value={endDate} // Use the 'name' state variable as the value
                  onChange={(event) => setEndDate(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status} // Use the 'name' state variable as the value
                  onChange={(event) => setStatus(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Enabled?
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={enabled} // Use the 'enabled' state variable as the checked value
                      onChange={(event) => setEnabled(event.target.checked)} // Update the 'enabled' state variable on change
                      name="enabled" // Name for the checkbox (optional)
                    />
                  }
                  label="Enabled"
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdatePayment}>Cancel</Button>
                  <Button onClick={saveOrUpdatePayment}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        {/* <Box>
          <SubscriptionProductList />
          <SubscriptionGroupList />
        </Box> */}
      </SystemDashboard>
    </Container>
  );
};

export default PaymentDetail;
